import script from "./IncomeContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeContainer.vue?vue&type=script&setup=true&lang=js"

import "./IncomeContainer.vue?vue&type=style&index=0&id=228a80dd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228a80dd"]])

export default __exports__